var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"trim-whitespace",rawName:"v-trim-whitespace"}],class:{progress: true, multi: _vm.pieces.length > 1}},_vm._l((_vm.pieces),function(piece,idx){return _c('div',{directives:[{name:"trim-whitespace",rawName:"v-trim-whitespace"}],key:idx,class:{'piece': true, [piece.color]: true},style:(piece.style)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }